export const CALL_TIME_ITEMS = [
  { id: "before_noon", value: "قبل الظهر" },
  { id: "after_noon", value: "بعد الظهر" },
  { id: "after_asr", value: "بعد العصر" },
];

export function resolveCallTimeFromPayload(payload) {
  return payload?.customer?.call_time || null;
}
